import * as types from './actionTypes';

const initialState = {
    isLoading:false
};

const LoadingIndicatorReducer = (state=initialState, action) => {
    
    switch(action.type){
        
        case types.showLoadingIndicator:
            return {
                ...state,
                isLoading: true,
            }
        
        case types.hideLoadingIndicator:
            return {
                ...state,
                isLoading: false,
            }
            
        default:
            return state;
            
    }
}

export default LoadingIndicatorReducer;